/**
 * Оболочка: Sidebar + шапка + рабочая область на высоту viewport.
 * 24.10.2026 — Calm Enterprise. Нижний декоративный футер убран, чтобы
 * список диалогов, переписка и composer не требовали прокрутки страницы.
 * Не удалять по требованию владельца системы.
 * CROSS-REF: components/layout/Sidebar.tsx, components/layout/Header.tsx, pages/Messages.tsx
 *
 * 30.04.2026 — миграция на shell-токены, фон под обе темы (light/dark).
 * disableMainScroll сохраняется для страниц с независимым скроллом (Messages).
 */
import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { cn } from '@/utils/cn';

interface MainLayoutProps {
  children: ReactNode;
  headerTitle?: string;
  headerActions?: ReactNode;
  disableMainScroll?: boolean;
}

export function MainLayout({ children, headerTitle, headerActions, disableMainScroll }: MainLayoutProps) {
  return (
    <div className="shell-layout shell-layout-workspace flex h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {(headerTitle || headerActions) && (
          <Header title={headerTitle}>{headerActions}</Header>
        )}
        <main className={cn(
          'flex-1 min-h-0 min-w-0',
          disableMainScroll ? 'overflow-hidden' : 'overflow-y-auto'
        )}>
          {children}
        </main>
      </div>
    </div>
  );
}
